var _rect, _mask, _rect2, _line, _line2, _path, _ellipse;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManualPayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 4,
    fill: "#78380C",
    fillOpacity: 0.1
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_39186_72116",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 27.4258,
    width: 29,
    height: 18.5743,
    rx: 1.5
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 27.4258,
    width: 29,
    height: 18.5743,
    rx: 1.5,
    stroke: "#78380C",
    strokeWidth: 4,
    mask: "url(#path-2-inside-1_39186_72116)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 22.2217,
    y1: 31.4844,
    x2: 25.055,
    y2: 31.4844,
    stroke: "#78380C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 39.9453,
    y1: 41.6172,
    x2: 42.7786,
    y2: 41.6172,
    stroke: "#78380C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.2793 21.3772L32.5015 18M32.5015 18L35.7237 21.3772M32.5015 18V25.7559",
    stroke: "#78380C",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.1184,
    cy: 35.818,
    rx: 3.03538,
    ry: 3.18133,
    fill: "#78380C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManualPayment);
export default __webpack_public_path__ + "static/media/manual_payment.eb88c4b4e838a4c67932cf2d8ddce04a.svg";
export { ForwardRef as ReactComponent };